import { apiGet, apiPatch } from './client';
import type { Inventory, InventoryBatchRequest } from '../types/Inventory';

// acc omitted/empty → all accounts.
export function getInventory(acc?: string): Promise<Inventory[]> {
  const q = acc ? `?acc=${encodeURIComponent(acc)}` : '';
  return apiGet<Inventory[]>(`/api/inventory${q}`);
}

// `acc` is the current filter; the server scopes the returned (post-save) rows
// to it so the grid stays on the same account after saving.
export function saveInventoryBatch(
  acc: string | undefined,
  added: Inventory[],
  modified: Inventory[],
  deletedIds: number[],
): Promise<Inventory[]> {
  return apiPatch<InventoryBatchRequest, Inventory[]>('/api/inventory/batch', {
    added,
    modified,
    deleted: deletedIds,
    acc: acc ?? null,
  });
}
